import React, { useCallback } from 'react';

import { useHistory } from 'react-router-dom';

// REDUX
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { educacaoClear } from 'store/modules/api/educacaoUpdate/actions';

// COMPONENTS
import RecuperaAtendimento from 'components/Pages/RecuperaAtendimento';

const RecuperarAtendimento: React.FC = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const { redirecionamento } = useSelector(
		(state: ApplicationState) => state.atendimento,
	);

	const handleClick = useCallback(() => {
		dispatch(educacaoClear());

		if (redirecionamento) {
			history.push(redirecionamento);
		}
	}, [dispatch, redirecionamento, history]);

	return <RecuperaAtendimento onClick={handleClick} />;
};

export default RecuperarAtendimento;
